import { JetView } from 'webix-jet';
import { devConfig, countries, profile, walletsList } from 'config/config';

/**
 * Class representing the view for filtering significant events and alterations reports.
 * @extends JetView
 */
export default class FilterSignificantEventsAndAlterationsReportsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            id: 'a1',
            margin: 5,
            rows: [
                {
                    responsive: 'a1',
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            id: 'Datepicker',
                            name: 'Datepicker',
                            view: 'text',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the date picker
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            id: 'Date',
                            name: 'Date',
                            view: 'datepicker',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the date input
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        screen.width > 600 ? {} : { height: 1, width: 0 }, // Responsive design adjustment
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing date inputs
                },
            ],
        };
        const buttons = {
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir Evento'), // Button to add an event
                    width: screen === 'small' ? 0 : 200,
                    maxWidth: 200,
                    hidden: !devConfig.getPermAction(
                        'EventsAndAlterationsAdd2',
                        'Add', // Permission check for adding events
                    ),
                    click: () => {
                        webix
                            .ui({
                                view: 'window',
                                id: 'addEventModal', // Modal for adding an event
                                fullscreen: screen.width < 500,
                                position: 'center',
                                modal: true,
                                head: _('Añadir Evento'), // Modal header
                                body: {
                                    view: 'form',
                                    id: 'addEventForm', // Form ID for adding an event
                                    width: screen.width < 500 ? 350 : 450,
                                    height: screen.width < 500 ? 600 : 400,
                                    elements: [
                                        {
                                            view: 'datepicker',
                                            label: _('Fecha y hora'), // Label for date and time input
                                            name: 'Date',
                                            id: 'Date',
                                            timepicker: true, // Enables time selection
                                            labelPosition: screen.width < 500 ? 'top' : 'left',
                                            labelWidth: 150,
                                            value: new Date(), // Default value for date and time
                                        },
                                        {
                                            view: 'text',
                                            label: 'ID Usuario', // Label for user ID input
                                            name: 'Users',
                                            id: 'Users',
                                            type: 'number',
                                            labelPosition: screen.width < 500 ? 'top' : 'left',
                                            labelWidth: 150,
                                            css: 'webix_inputNumber', // CSS class for number input
                                        },
                                        {
                                            view: 'text',
                                            label: _('Valor antes de la alteración'), // Label for value before alteration
                                            name: 'ValueBeforeAlteration',
                                            id: 'ValueBeforeAlteration',
                                            labelPosition: screen.width < 500 ? 'top' : 'left',
                                            labelWidth: 230,
                                        },
                                        {
                                            view: 'text',
                                            label: _('Valor después de la alteración'), // Label for value after alteration
                                            name: 'ValueAfterAlteration',
                                            id: 'ValueAfterAlteration',
                                            labelPosition: screen.width < 500 ? 'top' : 'left',
                                            labelWidth: 230,
                                        },
                                        {
                                            view: 'textarea',
                                            label: _('Motivo/descripción'), // Label for reason/description input
                                            name: 'ReasonDescription',
                                            id: 'ReasonDescription',
                                            labelPosition: 'top',
                                            inputHeight: 100,
                                            height: 130,
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: 'button',
                                                    value: 'Cancelar', // Cancel button
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide modal on cancel
                                                    },
                                                },
                                                {
                                                    view: 'button',
                                                    value: 'Guardar', // Save button
                                                    type: 'form',
                                                    click: function () {
                                                        const form = $$('addEventForm'); // Get form instance
                                                        if (form.validate()) {
                                                            // Validate form
                                                            console.log(
                                                                form.getValues(), // Log form values
                                                            );
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Set content type for AJAX request
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() +
                                                                        'es/Financial/AddSignificantEventsAndAlterations', // API endpoint for adding events
                                                                    {
                                                                        ...form.getValues(),
                                                                        Date: new Date(form.getValues().Date).getTime(), // Convert date to timestamp
                                                                    },
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message({
                                                                                title: _('¡Mensaje!'),
                                                                                type: 'alert-error',
                                                                                text: _(
                                                                                    'Ocurrio un error.', // Error message
                                                                                ),
                                                                            });
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            text = JSON.parse(
                                                                                text, // Parse response text
                                                                            );
                                                                            console.log(text);
                                                                            if (
                                                                                text.HasError // Check for errors in response
                                                                            ) {
                                                                                webix.message({
                                                                                    title: _('¡Mensaje!'),
                                                                                    type: 'alert-error',
                                                                                    text: _(
                                                                                        'Ocurrio un error al agregar el evento.', // Error message for adding event
                                                                                    ),
                                                                                });
                                                                            } else {
                                                                                webix.alert({
                                                                                    title: 'Notificación',
                                                                                    text: _(
                                                                                        'El evento se ha añadido correctamente', // Success message
                                                                                    ),
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                            this.getTopParentView().hide(); // Hide modal after saving
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    rules: {
                                        Date: webix.rules.isNotEmpty, // Validation rule for date
                                        Users: webix.rules.isNotEmpty, // Validation rule for user ID
                                        ReasonDescription: webix.rules.isNotEmpty, // Validation rule for reason/description
                                        ValueBeforeAlteration: webix.rules.isNotEmpty, // Validation rule for value before alteration
                                        ValueAfterAlteration: webix.rules.isNotEmpty, // Validation rule for value after alteration
                                    },
                                },
                            })
                            .show(); // Show the modal
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Button to clear form
                    width: screen == 'small' ? 0 : 100,
                    minWidth: 200,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect); // Reset country selection
                        $$('Datepicker').setValue(''); // Clear datepicker
                    },
                },
                {
                    id: 'consultDesk',
                    view: 'button',
                    value: _('Consultar'), // Button to consult/filter data
                    hotkey: 'enter', // Shortcut key for consult
                    type: 'form',
                    width: screen == 'small' ? 0 : 100,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter data from form
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date field if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker field if needed
                            }
                        }
                        this.app.callEvent(
                            'significantEventsAndAlterations:filter',
                            [filterdata], // Trigger filter event with data
                        );
                        $$('b5').collapse(); // Collapse filters section
                        $$('a5').scrollTo(100, 0); // Scroll to specific position
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'), // Button to clear second form
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset second form values
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect); // Reset country selection
                        $$('Datepicker').setValue(''); // Clear datepicker
                    },
                },
                {
                    id: 'consultDesk',
                    view: 'button',
                    value: _('Consultar'), // Button to consult/filter data
                    hotkey: 'enter', // Shortcut key for consult
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get filter data from second form
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date field if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker field if needed
                            }
                        }
                        this.app.callEvent(
                            'significantEventsAndAlterations:filter',
                            [filterdata], // Trigger filter event with data
                        );
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            id: 'b5',
                            header: _('Filtros'), // Header for filters section
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section for scrollable view
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup', // ID for filter popup
            fullscreen: true,
            modal: true,
            position: 'center',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for popup header
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon for popup
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            body: {
                view: 'form',
                id: 'myForm2', // ID for second form
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for form
                },
            },
        });
        return {
            id: 'myForm',
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion section if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if typeDate is not 2
                $$('Datepicker').show(); // Show datepicker
            } else {
                $$('Date').show(); // Show date input
                $$('Datepicker').hide(); // Hide datepicker
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
